import type { Route } from "~/interfaces";
import {getThemeData} from "~/utils";

export default defineNuxtRouteMiddleware(async (to, from) => {
  const config = getThemeData();
  try {
    const routesModule = await import(
      `../themes/${config.theme}/routes.ts`
    );
    const routes = routesModule.default;
    const currentRoute = getRoute(routes, to.path, "Home");
    const fromRoute = getRoute(routes, from.path, "Home");
    const hasLogin = routes.some((route: Route) => route.name === "Login");

    if (hasLogin) setStateValue("protected", true);

    to.meta = { ...to.meta, ...currentRoute.meta, name: currentRoute.name };
    from.meta = { ...from.meta, ...fromRoute.meta, name: fromRoute.name };
    return;
  } catch (error) {
    console.error(`Error importing routes from ${config.theme}:`, error);
  }
});
